class videopage {
  init() {
    this.popupEl = document.querySelector(".popuppage");
    this.videoEl = document.getElementById("popupVideopage");
    this.closeBtn = document.querySelector(".popuppage__close");
  }

  playvideo(src) {
    const videoSrc = src;
    if (!videoSrc) return;
    this.videoEl.src = videoSrc;
    this.showvideopage();
  }

  showvideopage() {
    this.initVideoControls();
    this.popupEl.classList.add("active");
    this.videoEl.play().catch((err) => {
      if (err.name !== "AbortError") console.error(err);
    });
  }

  hidevideopage(handler) {
    this.closeBtn.addEventListener("click", () => {
      this.popupEl.classList.remove("active");
      this.videoEl.pause();
      this.videoEl.currentTime = 0;
      this.detachVideoListeners();
      handler();
    });
  }

  initVideoControls() {
    // Re-select fresh video and controls each time popup opens
    this.videoEl = document.getElementById("popupVideopage");
    this.timeline = document.getElementById("timelinepage");
    this.playPauseBtn = document.querySelector(".playPausepage");
    this.muteBtn = document.querySelector(".muteunmutepage");
    this.timeDisplay = document.querySelector(".videotimepage");

    // 🚫 Before attaching again, remove previous listeners
    this.detachVideoListeners();

    // ✅ Then add them once
    this.bindVideoEvents();
  }

  detachVideoListeners() {
    if (!this.videoEl) return;

    this.playPauseBtn?.removeEventListener("click", this._onPlayPause);
    this.muteBtn?.removeEventListener("click", this._onMuteToggle);
    this.timeline?.removeEventListener("input", this._onSeek);
    this.videoEl?.removeEventListener("timeupdate", this._onTimeUpdate);
    this.videoEl?.removeEventListener("play", this._onPlayPauseIcon);
    this.videoEl?.removeEventListener("pause", this._onPlayPauseIcon);
    this.videoEl?.removeEventListener("ended", this._onVideoEnded);
  }

  bindVideoEvents() {
    if (!this.videoEl) return;

    // 🔹 Store handler references so we can remove them later
    this._onPlayPause = async () => {
      try {
        if (this.videoEl.paused) await this.videoEl.play();
        else this.videoEl.pause();
        this.updatePlayIcon();
      } catch (err) {
        if (err.name !== "AbortError") console.error(err);
      }
    };

    this._onMuteToggle = () => {
      this.videoEl.muted = !this.videoEl.muted;
      this.updateMuteIcon();
    };

    this._onSeek = () => {
      this.videoEl.currentTime = this.timeline.value;
    };

    this._onTimeUpdate = () => {
      if (!this.timeline) return;
      this.timeline.max = this.videoEl.duration || 0;
      this.timeline.value = this.videoEl.currentTime;
      this.updateTimeDisplay();
    };

    this._onPlayPauseIcon = () => this.updatePlayIcon();
    this._onVideoEnded = () => this.updatePlayIcon(true);

    // ✅ Add them once
    this.playPauseBtn.addEventListener("click", this._onPlayPause);
    this.muteBtn.addEventListener("click", this._onMuteToggle);
    this.timeline.addEventListener("input", this._onSeek);
    this.videoEl.addEventListener("timeupdate", this._onTimeUpdate);
    this.videoEl.addEventListener("play", this._onPlayPauseIcon);
    this.videoEl.addEventListener("pause", this._onPlayPauseIcon);
    this.videoEl.addEventListener("ended", this._onVideoEnded);
  }

  updatePlayIcon(forcePlay = false) {
    const playIcon = this.playPauseBtn.querySelector(".playpage");
    const pauseIcon = this.playPauseBtn.querySelector(".pausepage");

    if (forcePlay || this.videoEl.paused) {
      playIcon.style.display = "block";
      pauseIcon.style.display = "none";
    } else {
      playIcon.style.display = "none";
      pauseIcon.style.display = "block";
    }
  }

  updateMuteIcon() {
    const muteIcon = this.muteBtn.querySelector(".mutepage");
    const unmuteIcon = this.muteBtn.querySelector(".unmutepage");

    if (this.videoEl.muted) {
      muteIcon.style.display = "block";
      unmuteIcon.style.display = "none";
    } else {
      muteIcon.style.display = "none";
      unmuteIcon.style.display = "block";
    }
  }

  updateTimeDisplay() {
    if (!this.timeDisplay || !this.videoEl.duration) return;
    const current = this.formatTime(this.videoEl.currentTime);
    const total = this.formatTime(this.videoEl.duration);
    this.timeDisplay.textContent = `${current} / ${total}`;
  }

  formatTime(seconds) {
    if (isNaN(seconds)) return "0:00";
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${m}:${s}`;
  }
}

export default new videopage();
